import "./_section.scss";

import {ReactNode} from "react";

function Section({
  children,
  id,
}: {
  children?: ReactNode | undefined;
  id: string;
}): JSX.Element {
  return (
    <section id={id} className="section">
      {children}
    </section>
  );
}

export default Section;
